module.exports = __webpack_public_path__ + "img/chlg.240de8a6.png";